var A = Object.defineProperty, B = Object.defineProperties;
var F = Object.getOwnPropertyDescriptors;
var E = Object.getOwnPropertySymbols;
var G = Object.prototype.hasOwnProperty, L = Object.prototype.propertyIsEnumerable;
var I = (u, r, t) => r in u ? A(u, r, { enumerable: !0, configurable: !0, writable: !0, value: t }) : u[r] = t, g = (u, r) => {
  for (var t in r || (r = {}))
    G.call(r, t) && I(u, t, r[t]);
  if (E)
    for (var t of E(r))
      L.call(r, t) && I(u, t, r[t]);
  return u;
}, x = (u, r) => B(u, F(r));
var H = (u, r, t) => new Promise((b, h) => {
  var w = (o) => {
    try {
      n(t.next(o));
    } catch (v) {
      h(v);
    }
  }, C = (o) => {
    try {
      n(t.throw(o));
    } catch (v) {
      h(v);
    }
  }, n = (o) => o.done ? b(o.value) : Promise.resolve(o.value).then(w, C);
  n((t = t.apply(u, r)).next());
});
import "../../../node_modules/.pnpm/vue@3.5.18_typescript@5.2.2/node_modules/vue/dist/vue.runtime.esm-bundler.js";
import q from "./banjian/banjian.vue.js";
import J from "./chaungman/chaungman.vue.js";
import K from "./daogui/daogui.vue.js";
import Q from "./lianshen/lianshen.vue.js";
import U from "./lianshenhuabian/lianshenhuabian.vue.js";
import X from "./lichen/lichen.vue.js";
import Y from "./shalian/shalian.vue.js";
import Z from "./guahuabihua/guahuabihua.vue.js";
import ee from "./GroundMass/index.vue.js";
import ae from "./ShowerRoomModel/ShowerRoomModel.vue.js";
import { postPageCommodityFromOriginalES as oe } from "../../../request/commoditycenter/commodity/pageCommodityFromOriginalES/post.js";
import { defineComponent as te, computed as V, openBlock as N, createBlock as re, resolveDynamicComponent as le, createElementBlock as ne, createCommentVNode as ie, nextTick as S } from "../../../node_modules/.pnpm/@vue_runtime-core@3.5.18/node_modules/@vue/runtime-core/dist/runtime-core.esm-bundler.js";
import { markRaw as m, ref as f } from "../../../node_modules/.pnpm/@vue_reactivity@3.5.18/node_modules/@vue/reactivity/dist/reactivity.esm-bundler.js";
import { toDisplayString as se } from "../../../node_modules/.pnpm/@vue_shared@3.5.18/node_modules/@vue/shared/dist/shared.esm-bundler.js";
const ue = {
  key: 1,
  class: "error-message"
}, Oe = /* @__PURE__ */ te({
  __name: "TemplateView",
  props: {
    componentMap: { default: () => ({}) },
    params: { default: () => ({
      applicableProductChannels: [],
      pageNo: 1,
      pageSize: 10,
      productType: "STANDARD"
    }) }
  },
  emits: ["onSuccess", "hide-dialog"],
  setup(u, { expose: r, emit: t }) {
    const b = u, h = {
      banjian: m(q),
      chaungman: m(J),
      daogui: m(K),
      lianshen: m(Q),
      lianshenhuabian: m(U),
      lichen: m(X),
      shalianlichen: m(Y),
      beizhu: m(Z),
      shiji: m(ee),
      linyufang: m(ae)
    }, w = V(() => {
      const l = g({}, h);
      return b.componentMap && Object.keys(b.componentMap).forEach((e) => {
        const a = b.componentMap[e];
        typeof a == "string" && h[a] ? l[e] = h[a] : typeof a == "object" && a !== null && "setup" in a && (l[e] = m(a));
      }), l;
    }), C = t, n = f(""), o = f(null), v = f(null), d = f(-1), _ = f(null), P = f(""), i = f(null), O = f(null), j = f("zh-CN");
    let M = () => {
    };
    const T = V(() => {
      const l = d.value < 0 ? n.value : d.value.toString(), e = v.value ? v.value[l] : {}, a = _.value && d.value >= 0 ? _.value[d.value] : {};
      return x(g(g(g(g({}, e), o.value), Object.fromEntries(
        Object.entries(v.value || {}).filter(([s, p]) => !(o.value && s in o.value) && p != null && p !== "")
      )), a), {
        /** 用于过滤纱帘得定宽/定高下拉可选项 */
        _attributesFixedWidthHeight: e ? e.fixedWidthHeight : ""
      });
    }), R = (l) => {
      const { detailsParam: e, store: a, canEdit: s, orderParam: p, localeParam: y } = l;
      return P.value = s ? "create" : "view", O.value = p, j.value = y || "zh-CN", n.value = "", d.value = -1, new Promise((c, D) => {
        S(() => {
          var k;
          a ? (d.value = typeof e.classificationId == "number" ? e.classificationId : -1, n.value = ((k = a[d.value]) == null ? void 0 : k.classificationId) || "") : n.value = e.classificationId || "", o.value = e, _.value = a, W(o.value.commodityId), S(() => {
            i.value && (i.value.isShowDialog = !0);
          });
        }), M = c;
      });
    }, W = (l) => H(this, null, function* () {
      var a, s;
      const { data: e } = yield oe({
        pageNo: 1,
        pageSize: 10,
        id: l
      });
      if (e != null && e.records && ((a = e == null ? void 0 : e.records) != null && a.length)) {
        const p = e.records[0];
        let y = {};
        (s = p.attributes) == null || s.forEach((c) => {
          var D;
          c.attributeValues === null ? y[c == null ? void 0 : c.attributeCode] = c.attributeValues : y[c == null ? void 0 : c.attributeCode] = (D = c.attributeValues) == null ? void 0 : D.toString();
        }), v.value = y;
      }
    }), $ = (l, e) => {
      var a;
      i.value && (n.value === "11" && i.value.formData.attachments && i.value.formData.attachments.length && ((a = i.value.formData.remark) != null ? a : "").indexOf("加工见附件") !== 0 && (i.value.formData.remark = "加工见附件！" + i.value.formData.remark), _.value && d.value >= 0 ? n.value === "1" && (Object.keys(o.value || {}).forEach((s) => {
        ![
          "productHeight",
          "productWidth",
          "mainA",
          "leftCurtainWidth",
          "middleCurtainWidth",
          "rightCurtainWidth"
        ].includes(s) && Object.prototype.hasOwnProperty.call(l, s) && o.value && (o.value[s] = l[s]);
      }), _.value.forEach((s) => {
        var p;
        s.classificationId === "2" && (s.productHeight = (p = o.value) == null ? void 0 : p.productHeight);
      })) : o.value, i.value.isShowDialog = !1, C("onSuccess", i.value.formData), M(i.value.formData));
    }, z = () => {
      S(() => {
        i.value && (i.value.isShowDialog = !1);
      }), C("hide-dialog");
    };
    return r({
      show: R
    }), (l, e) => w.value[n.value] ? (N(), re(le(w.value[n.value]), {
      key: 0,
      params: l.params,
      options: T.value,
      showerRoomModelParams: l.params,
      showerRoomModelOptions: T.value,
      ref_key: "tempComponent",
      ref: i,
      onOnSuccess: $,
      onHideDialog: z,
      orderParam: O.value,
      openType: P.value,
      locale: j.value
    }, null, 40, ["params", "options", "showerRoomModelParams", "showerRoomModelOptions", "orderParam", "openType", "locale"])) : n.value ? (N(), ne("div", ue, '未找到类型 "' + se(n.value) + '" 对应的组件', 1)) : ie("", !0);
  }
});
export {
  Oe as default
};



//////////////////
// WEBPACK FOOTER
// ./~/@oppein/op-web-components/dist/es/components/configuration-goods/components/TemplateView.vue.js
// module id = 1241
// module chunks = 67